/**
 * Show sticky header when window.scrollY sufficiently large.
 */
export const stickyScroll = (isMobile: boolean, isMCUFeed: boolean, isUI_202506: boolean) => {
    if (typeof window !== 'undefined') {
        const handleScroll = () => {
            const sellerInfoBlock: any = document.querySelector('.seller-info-block-container');
            const stickyHeader = document.querySelector('[data-q="sticky-banner"]') as HTMLElement;
            const header = document.querySelector('.header');
            const pushdown = document.querySelector('.banner');
            const vipContent = (document.querySelector('[data-q="footer-container"]') || document.querySelector('main')) as HTMLElement;
            const targetLine =
                sellerInfoBlock.offsetTop +
                (header && pushdown ? header.clientHeight + pushdown.clientHeight : null) +
                sellerInfoBlock.clientHeight;

            if (stickyHeader) {
                const isStickyAtBottom = (isMCUFeed && isMobile) || isUI_202506;
                const stickyHeaderHeight = stickyHeader.offsetHeight;
                
                if (sellerInfoBlock && !isMobile) {
                    const shouldShow = window.scrollY > targetLine;
                    stickyHeader.classList.toggle('is-shown', shouldShow);
                    
                    // Add/remove bottom padding for desktop sticky header
                    if (vipContent) {
                        if (shouldShow) {
                            vipContent.style.paddingBottom = `${stickyHeaderHeight + 10}px`;
                        } else {
                            vipContent.style.paddingBottom = '';
                        }
                    }
                } else {
                    if (isMCUFeed) {
                        stickyHeader.id = 'is-shown-bottom';
                    }

                    if (isUI_202506) {
                        // always fixed bottom, no toggle
                        // stickyHeader.classList.toggle('is-shown', true);
                    } else {
                        const shouldShow = window.scrollY > 0;
                        stickyHeader.classList.toggle('is-shown', shouldShow);
                    }
                    
                    // Add/remove bottom padding for mobile sticky header at bottom
                    if (isStickyAtBottom && vipContent) {
                        vipContent.style.paddingBottom = `${stickyHeaderHeight + 20}px`;
                    } else if (vipContent) {
                        vipContent.style.paddingBottom = '';
                    }
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        
        // Return cleanup function
        return () => {
            window.removeEventListener('scroll', handleScroll);
            // Reset padding when unmounting
            const vipContent = (document.querySelector('[data-q="footer-container"]') || document.querySelector('main')) as HTMLElement;
            if (vipContent) {
                vipContent.style.paddingBottom = '';
            }
        };
    }
    
    return () => {}; // Return empty cleanup function for server-side rendering
};
